// @flow
import React, { PureComponent } from 'react';

class NextGenComponentsVersions extends PureComponent {
    render() {
        return <div>Hello from custom component version :D</div>;
    }
}
export default NextGenComponentsVersions;
